export default "__VITE_ASSET__cNqbx7LW__"